import KeyUtil from './util/KeyUtil';

let dropdowns;

function init() {
  dropdowns = document.querySelectorAll('.linkListDd__wrap');
  
  dropdowns.forEach(ddWrap => {
    const toggle = ddWrap.querySelector('.linkListDd__toggle');
    toggle.addEventListener('click', () => toggleDropdown(toggle));
    KeyUtil.disableDefaultArrowPresses(ddWrap);
    ddWrap.addEventListener('keydown', handleDropdownKeyPress);
  })
}

function handleDropdownKeyPress(e) {
  const dropdown = this.closest('.linkListDd__wrap');
  const toggle = dropdown.querySelector('.linkListDd__toggle');
  const dropdownEl = dropdown.querySelector('.linkListDd');
  
  if (!dropdownEl) { window.y = dropdown; }
  const linkItems = dropdownEl.querySelectorAll('.linkListDd__item');
  const itemCount = linkItems.length;
  const isOpen = dropdown.classList.contains('linkListDd__wrap--open');
  const key = event.key;

  if ('Escape' === key) {
    toggleDropdown(toggle, false);
    return;
  };

  /* If the toggle is open, ignore keypresses unless it's a Down, Enter, or Space on the toggle itself */
  if (!isOpen) {
    const isOpenKey = (key === 'ArrowDown' || key === ' ' || key === 'Enter');
    
    if (isOpenKey && !!this.closest('.linkListDd__toggle')) {
      toggleDropdown(toggle, true);
    }

    return;
  }

  let crement = null;
  
  if ('ArrowUp' === key) {
    crement = -1;
  }
  else if ('ArrowDown' === key) {
    crement = 1;
  }

  if (crement !== null) {
    const selectedIdx = getSelectedIdx(dropdown);
    let nextIdx;

    // No item is selected?  Select the toggle button       
    if (selectedIdx === null) {
      nextIdx = -1;
    }
    else {
      const maxIdx = itemCount - 1;
      nextIdx = selectedIdx + crement;
      
      if (nextIdx < -1) { nextIdx = maxIdx; }
      else if (nextIdx > maxIdx) { nextIdx = -1; }
    }

    if (nextIdx === -1) {
      toggle.focus();
    }
    else {
      linkItems[nextIdx].querySelector('a').focus();
    }
  }
}

function getSelectedIdx(dropdown) {
  const toggle = dropdown.querySelector('.linkListDd__toggle');

  if (document.activeElement === toggle) { return -1; }
    
  const itemLinks = Array.from(dropdown.querySelectorAll('.linkListDd__item a'));
  const selectedItem = itemLinks.find(t => document.activeElement === t);
  const idx = itemLinks.indexOf(selectedItem);
  
  // Null indicates no selected index at all
  if (idx < 0) { return null; }
  return idx;
}

function toggleDropdown(toggle, shouldOpen = null) {
  const dropdown = toggle.closest('.linkListDd__wrap');
  const targetId = toggle.getAttribute('aria-controls');
  const target = document.getElementById(targetId);
  const isOpen = (toggle.getAttribute('aria-expanded') === 'true');

  if (shouldOpen === isOpen) { return; }
  
  const isOpening = (shouldOpen !== null) ? shouldOpen : !isOpen;

  // Close other dropdowns
  if (isOpening) {
    Array.from(dropdowns)
      .filter(dd => dd !== dropdown)
      .forEach(otherDropdown => { 
        toggleDropdown(otherDropdown.querySelector('.linkListDd__toggle'), false);
      });
  }
  
  toggle.setAttribute('aria-expanded', isOpening ? 'true' : 'false');
  dropdown.classList.toggle('linkListDd__wrap--open', isOpening);
}

export default { init };
